import { useMemo, useCallback } from "react"

import { isAfter, parseISO } from "date-fns"

import {
    IMAGE_SELECTED_SOURCE,
    IMAGE_SELECTED_LAYER,
    IMAGE_SELECTED_BORDER_LAYER,
    useOrderingLayers,
    Layer,
    Marker,
    useMapStateContext,
    MapStyles,
} from "@l2r-front/l2r-map"
import {useTheme} from "@l2r-front/l2r-ui"
import { getColorWithOpacity } from "@l2r-front/l2r-utils"

import { VIEW_FINDER_ENABLED_SINCE } from "../../constants/imageDates"
import { useImageCollectionDispatchContext, useImageCollectionStateContext } from "../../contexts/ImageCollectionContext"
import { getImageSelectedBorderConfig, getImageSelectedConfig } from "../../utils/getImageCollectionConfig"

import { ImageSelectedSource } from "../ImageSelectedSource"

import * as Styled from "./ImageSelectedLayer.styled"

export function ImageSelectedLayer() {

    const { setImageFeatureIdClicked } = useImageCollectionDispatchContext()
    const { displayedImagePosition, imageCollection, imageAngle, imageLayerDisplayed } = useImageCollectionStateContext()
    const imageCollectionDate = imageCollection?.date ? parseISO(imageCollection?.date) : null

    const imageSelectedLayerConfig = useMemo(() => {
        return getImageSelectedConfig()
    }, [])

    const imageSelectedLayerBorderConfig = useMemo(() => {
        return getImageSelectedBorderConfig()
    }, [])

    useOrderingLayers([IMAGE_SELECTED_BORDER_LAYER, IMAGE_SELECTED_LAYER])

    const handleClick = useCallback(async (event) => {
        const feature = event?.feature

        if (!feature) {
            return
        } else {
            setImageFeatureIdClicked(feature.properties.uuid)
        }
    }, [setImageFeatureIdClicked])
    const { getCurrentMapStyle } = useMapStateContext()

    const mapStyle = getCurrentMapStyle()
    const theme = useTheme()
    
    const dateAllowDisplayViewCone = imageCollectionDate ? isAfter(imageCollectionDate, parseISO(VIEW_FINDER_ENABLED_SINCE)) : false 
    const shouldDisplayViewCone = imageLayerDisplayed && displayedImagePosition && dateAllowDisplayViewCone && (typeof imageAngle === "number")
    const viewConeColor = mapStyle === MapStyles.plan ?  getColorWithOpacity(theme.palette.map.darkReferential, 0.5)
        : getColorWithOpacity(theme.palette.map.lightReferential, 0.95)

    return (
        <>
            <ImageSelectedSource
                id={IMAGE_SELECTED_SOURCE}
                tolerance={.001}
            >
                <Layer
                    id={IMAGE_SELECTED_BORDER_LAYER}
                    {...imageSelectedLayerBorderConfig}
                    onClick={handleClick}
                />
                <Layer
                    id={IMAGE_SELECTED_LAYER}
                    {...imageSelectedLayerConfig}
                />
            </ImageSelectedSource>
            {shouldDisplayViewCone && (
                <Marker
                    anchor="bottom"
                    latitude={displayedImagePosition.lat}
                    longitude={displayedImagePosition.lng}
                    style={{ pointerEvents: "none" }}
                >
                    <Styled.ViewConeIcon color={viewConeColor} rotation={imageAngle} />
                </Marker>
            )}
        </>
    )
}